import request from '../request.js'

//全局查询 右侧表格得数据 --- 郑志会
const selectAnalysis = function (data) {
    return request({
        url: 'busDetailedAnalysisAppraisal/selectAnalysis',
        method: 'post',
        data
    })
}
//查询右侧 下拉框 得数据
const selectConditionArray = function (data) {
    return request({
        url: 'busDetailedAnalysisAppraisal/selectConditionArray',
        method: 'post',
        data
    })
}

// 获取默认模板 数据
const getDefaultValue = function (data) {
    return request({
        url: 'busDetailedAnalysisAppraisal/getConditionValue',
        method: 'post',
        data
    })
}

//查询右侧 下拉框 得数据
const getProjectTreeJsonById = function (data) {
    return request({
        url: 'busProContract/getProjectTreeJsonById',
        method: 'post',
        data
    })
}

// 自动分析 --- 叶凡
const getLaborData = function (data) {
    return request({
        url: 'labor/getLaborData',
        method: 'post',
        data
    })
}

// 保存说明 --- 叶凡
const saveRemarks = function (data) {
    return request({
        url: 'analysisRemark/saveRemark',
        method: 'post',
        data
    })
}

// 说明详细 --- 叶凡
const getRemarks = function (data) {
    return request({
        url: 'analysisRemark/getUserRemarks',
        method: 'post',
        data
    })
}

//签证对比--页面条件查询的参数-----叶凡
const getVisaConditions = function (data) {
    return request({
        url: 'visaCostDetail/getVisaConditions',
        method: 'post',
        data
    })
}

//签证对比--查询接口-----叶凡
const getVisaData = function (data) {
    return request({
        url: 'visaDetailAnalysis/getVisaData',
        method: 'post',
        data
    })
}

//获取清单名称、计量单位下拉框选项
const getUnitsAndNames = function (data) {
    return request({
        url: 'visaDetailAnalysis/getUnitsAndNames',
        method: 'post',
        data
    })
}

export {
    getRemarks,
    saveRemarks,
    getVisaData,
    getLaborData,
    selectAnalysis,
    getDefaultValue,
    getUnitsAndNames,
    getVisaConditions,
    selectConditionArray,
    getProjectTreeJsonById
}
